exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-a5a22442]::-webkit-inner-spin-button,input[data-v-a5a22442]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-a5a22442]{-moz-appearance:textfield}.tanpawrap[data-v-a5a22442]{white-space:nowrap}", ""]);

// exports
